import { render } from "./myprofile.template.html?vue&type=template&id=5bbde366&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=ts"
export * from "./MyProfile.vue?vue&type=script&lang=ts"

import "./MyProfile.vue?vue&type=style&index=0&id=5bbde366&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bbde366"

export default script